import LineTabs from 'components/tabs/LineTabs';
import PillTabs from 'components/tabs/PillTabs';

/**
 * The tabs of a side panel, under its header, kept in place while the body
 * scrolls. `variant`: `line` (underlined in orange: a task, an appointment) or
 * `pill` (grey buttons with their count: a temp worker). Space under them:
 * the body only has 0.5rem on top, fitted for content right under the title.
 * `children`: what sits on the line of the tabs, positioned by the caller.
 */
const SlideOverTabs = ({ tabs, activeTab, onChange, variant = 'line', children }) => (
  <div className="relative flex-shrink-0 px-4 pb-4 md:px-6">
    {variant === 'pill' ? (
      <PillTabs activeTab={activeTab} onChange={onChange} tabs={tabs} />
    ) : (
      <LineTabs activeTab={activeTab} onChange={onChange} tabs={tabs} />
    )}
    {children}
  </div>
);

export default SlideOverTabs;
